import React from "react";

const FailureModal = ({ isOpen, theme = "light", language = "en" }) => {
  if (!isOpen) return null;

  const isRTL = language === "ar";

  return (
    <>
      <style>{`
        @keyframes ccFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes ccSlideUp {
          from { transform: translateY(32px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes errormark-stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes errormark-scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.15, 1.15, 1);
          }
        }
        @keyframes errormark-fill {
          100% {
            box-shadow: inset 0px 0px 0px 40px ${
              theme === "dark" ? "rgba(239, 68, 68, 0.15)" : "rgba(220, 38, 38, 0.1)"
            };
          }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          background: theme === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 11000,
          animation: "ccFadeIn 0.25s ease-out",
          overflow: "hidden",
          overscrollBehavior: "contain",
          willChange: "backdrop-filter",
        }}
      >
        <div
          style={{
            background: theme === "dark" ? "#1e293b" : "#ffffff",
            border: `1px solid ${
              theme === "dark" ? "rgba(148, 163, 184, 0.15)" : "rgba(226, 232, 240, 0.8)"
            }`,
            padding: "40px 60px",
            borderRadius: "28px",
            boxShadow:
              theme === "dark"
                ? "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
                : "0 25px 50px -12px rgba(0, 0, 0, 0.12)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            minWidth: "220px",
            animation: "ccSlideUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
        >
          {/* Drawing X Mark SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            style={{
              width: "72px",
              height: "72px",
              borderRadius: "50%",
              display: "block",
              strokeWidth: "4.5",
              stroke: theme === "dark" ? "#ef4444" : "#dc2626",
              strokeMiterlimit: "10",
              fill: "none",
              animation:
                "errormark-scale 0.35s ease-in-out 0s both, errormark-fill 0.4s ease-in-out 0.4s forwards",
            }}
          >
            <circle
              cx="26"
              cy="26"
              r="23.5"
              style={{
                strokeDasharray: "166",
                strokeDashoffset: "166",
                strokeWidth: "4.5",
                strokeMiterlimit: "10",
                stroke: theme === "dark" ? "#ef4444" : "#dc2626",
                fill: "none",
                animation: "errormark-stroke 0.65s cubic-bezier(0.65, 0, 0.45, 1) forwards",
              }}
            />
            <path
              d="M16 36l20-20M36 36l-20-20"
              style={{
                transformOrigin: "50% 50%",
                strokeDasharray: "60",
                strokeDashoffset: "60",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                animation:
                  "errormark-stroke 0.35s cubic-bezier(0.65, 0, 0.45, 1) 0.55s forwards",
              }}
            />
          </svg>

          {/* Error Text */}
          <span
            style={{
              fontSize: "19px",
              fontWeight: "750",
              color: theme === "dark" ? "#f1f5f9" : "#0f172a",
              letterSpacing: isRTL ? "0" : "0.5px",
              textAlign: "center",
            }}
          >
            {isRTL ? "خطأ" : "Error"}
          </span>
        </div>
      </div>
    </>
  );
};

export default FailureModal;
